var map = {
	"./Canal.stl": 818505,
	"./JointDiskLeft.stl": 401439,
	"./JointDiskRight.stl": 36955,
	"./Mandibula.stl": 166254,
	"./Skull.stl": 255835,
	"./softTissue.stl": 993551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 156447;